/**
 * Pentavite — shopper-facing gift tweaks.
 *
 * 1) Short gift names. The free-gift products carry long titles and BOGOS
 *    clones them for the cart ("🎁 … (100% off)"). Shoppers should just see
 *    the plain product name. Only nodes that actually contain those markers
 *    are rewritten — nothing is hidden, moved or re-scanned wholesale.
 *
 * 2) Gift slider gate. BOGOS can only target whole pages, so its "Select your
 *    free gift" slider also pops up on the home page and product pages. It
 *    should only greet shoppers who have the cart open. Instead of letting it
 *    appear and closing it a moment later (which flashed on screen), we mark
 *    the slider the instant it is inserted and keep it invisible (visibility,
 *    not display, so the carousel still lays out) until the mini cart is open
 *    (or the shopper is on /cart).
 */
(function () {
  if (window.pvGiftNameFix) return;
  window.pvGiftNameFix = true;

  /* ------------------------------------------------------------------ *
   * 1. Short gift names
   * ------------------------------------------------------------------ */
  var GIFT_MARKERS = /🎁|100%\s*off|\((?:19|20)\d{2}\s*Q\d/i;
  var STRIP = /\s*(?:🎁|\(\s*100%\s*off\s*\)|\(\s*(?:19|20)\d{2}\s*Q\d[^)]*\))\s*/gi;
  var STRIP_COLOUR = /\s*[–—-]\s*Green\b/gi;
  var SELECTOR = 'a, div, span, p, td, th, li, strong, b, h1, h2, h3, h4, h5, .cart-item__name';

  function clean(text) {
    return String(text || '')
      .replace(STRIP, ' ')
      .replace(STRIP_COLOUR, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function run() {
    var nodes;
    try {
      nodes = document.querySelectorAll(SELECTOR);
    } catch (error) {
      return;
    }
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.children.length) continue; // only leaf text nodes
      var text = node.textContent || '';
      if (!GIFT_MARKERS.test(text)) continue;
      var cleaned = clean(text);
      // Allow an empty result: the suffix is sometimes its own element,
      // e.g. <div>Pentavite Wallet <span>(2026 Q4 Edition)</span></div>
      if (cleaned !== text.trim()) node.textContent = cleaned;
    }
  }

  run();
  document.addEventListener('click', function () {
    window.setTimeout(run, 400);
    window.setTimeout(run, 1500);
  }, true);
  window.setInterval(run, 1500);

  /* ------------------------------------------------------------------ *
   * 2. Gift slider gate
   * ------------------------------------------------------------------ */
  var SLIDER_TEXT = /select your free gift/i;
  var GATE_ATTR = 'data-pv-gift-gate';
  var gated = [];

  // Members whose cart has unlocked the gift may see BOGOS' picker on any page.
  function sliderAllowed() {
    if (window.__pvGiftAllow) return true;
    return cartIsOpen();
  }

  function cartIsOpen() {
    // On the cart page the cart *is* the page — never gate the slider there.
    if (window.location.pathname.indexOf('/cart') === 0) return true;
    try {
      return !!(window.Alpine && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').open);
    } catch (error) {
      return false;
    }
  }

  function ensureGateStyle() {
    if (document.getElementById('pv-gift-gate-style')) return;
    var style = document.createElement('style');
    style.id = 'pv-gift-gate-style';
    // Purely cosmetic switch: it flips an attribute we own, so it cannot
    // touch the page, the drawer or the add-to-cart flow.
    // visibility (not display) keeps the slider laid out, so its carousel and
    // lazy images still initialise correctly when the cart opens.
    style.textContent = '[' + GATE_ATTR + '] { visibility: hidden !important; pointer-events: none !important; }';
    (document.head || document.documentElement).appendChild(style);
  }

  // Never mark anything that could be (or contain) the page itself — that is
  // what once blanked the whole site out.
  function isPageShell(node) {
    if (!node || node.nodeType !== 1) return true;
    if (node === document.body || node === document.documentElement) return true;
    if (node.id === 'MainContent' || node.tagName === 'MAIN') return true;
    if (node.classList && (node.classList.contains('shopify-section') ||
      node.classList.contains('shopify-section-group'))) return true;
    return false;
  }

  // Walk up from a node inside the slider to its outermost wrapper.
  function sliderRoot(node) {
    var root = null;
    var el = node;
    while (el && el.nodeType === 1 && !isPageShell(el)) {
      if (SLIDER_TEXT.test(el.textContent || '')) root = el;
      el = el.parentElement;
    }
    return root;
  }

  function gateSlider(root) {
    root.setAttribute(GATE_ATTR, '1');
    if (gated.indexOf(root) === -1) gated.push(root);
  }

  function ungateSlider() {
    while (gated.length) {
      var el = gated.pop();
      if (el && el.removeAttribute) el.removeAttribute(GATE_ATTR);
    }
  }

  // BOGOS keeps its own open/closed state; pressing its Close button while the
  // slider is invisible keeps that state honest (no stuck overlay afterwards).
  function pressOwnClose(root) {
    var buttons;
    try {
      buttons = root.querySelectorAll('button, [role="button"]');
    } catch (error) {
      return;
    }
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var label = (((button.getAttribute && button.getAttribute('aria-label')) || '') + ' ' +
        (button.textContent || '')).trim();
      if (/^close$/i.test(label)) {
        button.click();
        return;
      }
    }
  }

  function handleCandidate(node) {
    if (!node || node.nodeType !== 1) return;
    if (sliderAllowed()) {
      ungateSlider();
      return;
    }
    var text;
    try {
      text = node.textContent || '';
    } catch (error) {
      return;
    }
    if (text.length > 60000) return; // page-sized wrapper, not the slider
    if (!SLIDER_TEXT.test(text)) return;
    var root = sliderRoot(node);
    if (!root) return;
    ensureGateStyle();
    gateSlider(root);
    pressOwnClose(root);
  }

  // Catch the slider in the same task it is inserted, so it never paints.
  try {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) handleCandidate(added[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (error) {}

  // Safety net for anything that was already in the DOM, plus the moment the
  // shopper opens or closes the mini cart.
  window.setInterval(function () {
    if (cartIsOpen()) {
      ungateSlider();
      return;
    }
    var children = document.body ? document.body.children : [];
    for (var i = 0; i < children.length; i++) handleCandidate(children[i]);
  }, 300);

  /**
   * Reminder logic: if the shopper still hasn't picked a gift and the cart still
   * qualifies, nudge the theme to re-render the cart the next time they open the
   * drawer (or land on the cart page) so BOGOS shows its gift slider again.
   * Nothing is written to the cart — we only re-render, which is what BOGOS
   * reacts to. Runs at most once per cart opening.
   */
  var reminderArmed = false;
  var reminderBusy = false;

  function sliderVisible() {
    try {
      return (document.body.textContent || '').indexOf('Select your free gift') !== -1;
    } catch (error) {
      return false;
    }
  }

  function checkGiftReminder() {
    if (!sliderAllowed()) {
      reminderArmed = false;
      return;
    }
    if (reminderArmed || reminderBusy) return;
    reminderArmed = true;
    if (sliderVisible()) {
      ungateSlider(); // it is already there — just let it show
      return;
    }
    reminderBusy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var total = cart.items_subtotal_price || 0;
        var hasGift = (cart.items || []).some(function (item) {
          return item.price === 0 || /freegift|100%\s*off|\uD83C\uDF81/i.test((item.title || '') + (item.handle || ''));
        });
        if (total < 8000 || hasGift) return;
        try {
          var store = window.Alpine && Alpine.store('xMiniCart');
          if (store && typeof store.reLoad === 'function') store.reLoad();
        } catch (error) {}
      })
      .catch(function () {})
      .then(function () { reminderBusy = false; });
  }

  window.setInterval(checkGiftReminder, 700);

})();
